import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent, SoftphoneService } from 'lib-trend-core';

/**
 * Centered call modal. Reads everything from the (singleton) SoftphoneService so it can be opened,
 * minimized and re-opened without losing the live call.
 */
@Component({
    selector: 'softphone-call-dialog',
    templateUrl: './softphone-call-dialog.component.html',
    styleUrls: ['./softphone-call-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SoftphoneCallDialogComponent extends AbstractComponent {

  constructor(
    injector: Injector,
    public softphone: SoftphoneService,
    private dialogRef: MatDialogRef<SoftphoneCallDialogComponent>,
  ) {
    super(injector);
  }

  /** Close the modal WITHOUT ending the call — the host turns this into a minimize (pill in the topbar). */
  minimize(): void {
    this.dialogRef.close();
  }

  /** End the call; the host then closes the modal automatically. */
  hangup(): void {
    this.softphone.hangup();
  }
}
